// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2106":"1e4765489440215e","2888":"94a4e583afe25a0d","7699":"1e4765489440215e","8892":"1e4765489440215e"}[chunkId] + ".css";
};